import './Fieldset.scss'
import React from 'react'

const Fieldset = ({ label, children, ...rest }) => {
  return (
    <fieldset {...rest} className='Fieldset'>
      <div className='Fieldset_wrapper'>
        <h6 className='Fieldset_label'>
          {label}
        </h6>
        <div className='Fieldset_content'>
          {children}
        </div>
      </div>
    </fieldset>
  )
}

export default Fieldset



// WEBPACK FOOTER //
// ./src/lib/form/Fieldset.js